import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {Route, Router, Routes} from '@angular/router';
import {catchError, map} from 'rxjs/operators';
import {HomeComponent} from '../../Menus/Home/home.component';
import {WebXmlComponent} from './webxml.component';

import {HttpClient} from '@angular/common/http';
import {FullLayoutComponent} from 'app/core-ui/abstract/layouts/full-layout.component';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {SecurityService} from 'app/core-ui/abstract/services/security.service';
import {DetailsComponent} from '../../Mail/details.component';
import {ListComponent} from '../../Mail/list.component';

@Injectable()
export class RoutesService extends SecurityService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
    public webxml: WebXmlComponent,
  ) {
    super(http, configService, eventsEmitterService, router, logger);
  }

  getRoutesForUser(langid): Observable<any> {
    let serviceUrl = this.baseUrl + 'RoutesService/getRoutesByPerId?langId=' + langid;
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  /*
   * Called after successful login
   * and every refresh / URL type
   */
  public getRoutes(url: string) {
    this.getRoutesForUser(localStorage.getItem('langId')).subscribe({
      next: (data) => {
        //Get initial Route configurations
        let routerConfig = this.router.config;
        let childRoutes: Routes = [];

        // Allow both SSO & login
        // if(this.configService.getIsLogoutExternal()){
        //     routerConfig.forEach((element, index) => {
        //         if(element.path == "login"){
        //             routerConfig.splice(index, 1);
        //         }
        //     });
        // }else{
        //      routerConfig.forEach((element, index) => {
        //         if(element.path == "sso"){
        //             routerConfig.splice(index, 1);
        //         }
        //     });
        // }

        this.logger.log(routerConfig);
        //Add a Route item for every menu in DB
        for (let i in data) {
          let routerItem: Route = {};
          //if a Component String is matching get it's Object
          routerItem.component = this.webxml.getComponent(data[i].component);
          routerItem.path = data[i].path;
          routerItem.data = {
            lang1: data[i].lang1,
            lang2: data[i].lang2,
          };
          childRoutes.push(routerItem);
        }

        //Add Generic pages available to all Users

        //Home Page
        let routerHome: Route = {};
        routerHome.component = HomeComponent;
        routerHome.path = 'home';
        routerHome.data = {
          lang1: 'Αρχική',
          lang2: 'Home',
        };
        childRoutes.push(routerHome);

        //Mailing
        let list: Route = {};
        list.component = ListComponent;
        list.path = 'list';
        list.data = {
          lang1: 'Μηνύματα',
          lang2: 'Messages',
        };
        childRoutes.push(list);

        /*
                    let compose:Route = {};
                    compose.component = ComposeComponent;
                    compose.path = 'compose';
                    compose.data = {
                        title : 'Compose'
                    }
                    childRoutes.push(compose);  
                    */

        let details: Route = {};
        details.component = DetailsComponent;
        details.path = 'details';
        details.data = {
          lang1: 'Λεπτομέρειες',
          lang2: 'Details',
        };
        childRoutes.push(details);

        //Add Layout template used by every menu
        //and the above created children
        const routerConst = {
          path: 'menu',
          component: FullLayoutComponent,
          data: {
            lang1: 'Λεπτομέρειες',
            lang2: 'Details',
          },
          children: childRoutes,
        };
        //Reinitialise Routes
        this.logger.log(routerConst);
        routerConfig.unshift(routerConst);
        this.router.resetConfig(routerConfig);

        /*
         * Handling refresh / URL typing
         */
        //clear url of parameters
        let withoutparams = url.split(';');
        url = withoutparams[0];

        let jsio: any = {};

        for (let index = 1; index < withoutparams.length; index++) {
          let params = withoutparams[index].split('=');
          if (params.length > 1) {
            jsio[params[0].toString()] = params[1].toString();
          }
        }

        //handle randonmness of "/" starting
        if (url.indexOf('/') == 0) {
          url = url.substr(1, url.length);
        }
        this.logger.log('typed url: ' + url);

        if (url.indexOf('/') >= 0 && url.indexOf('menu') == 0) {
          let URLarray = url.split('/');
          if (URLarray.length > 1) {
            let menuId = URLarray[1];

            //create string of menuIds to check against typed url
            let menuListStr = '##';
            routerConfig.forEach((element) => {
              if (element.children) {
                element.children.forEach((child) => {
                  menuListStr += child.path + '##'; // delimiter
                });
              }
            });
            //this.logger.log(menuListStr)
            //this.logger.log(menuId)
            if (menuListStr.indexOf(menuId) > 0) {
              //only accept urls after 1 slash
              url = URLarray[0] + '/' + URLarray[1];
              this.logger.log('final url:' + url);

              //trick to handle refresh
              //(Router doesnt refresh page if navigated to same exact URL)
              //so dummy params are added/removed to detect URL change
              if (withoutparams.length == 1) {
                this.router.navigate([url, {refresh: 'refresh'}]);
              } else {
                let refreshFound: boolean = false;
                Object.keys(jsio).forEach((element) => {
                  if (jsio[element] == 'refresh') {
                    refreshFound = true;
                  }
                });

                if (refreshFound) {
                  delete jsio.refresh;
                } else {
                  jsio.refresh = 'refresh';
                }

                this.router.navigate([url, jsio]);
              }

              //All check failures redirect to home
            } else {
              this.router.navigateByUrl('menu/home');
            }
          } else {
            this.router.navigateByUrl('menu/home');
          }
        } else {
          this.router.navigateByUrl('menu/home');
        }
      },
      error: (error) => {
        this.logger.log('Route initialization service has failed');
        this.goToLogin('routes', 'fail');
      },
    });
  }
}
